'use client';

import ReactDOM from 'react-dom';

export function TradeInEventsPagePreloadVideo({ mobile }: { mobile: boolean }) {
  ReactDOM.preload(
    mobile
      ? require('~/public/static/trade-in/mov.mp4')
      : require('~/public/static/trade-in/mov2x.mp4'),
    {
      as: 'video',
    },
  );

  return null;
}
